export function getIPv6SubnetValue(index: number): number {
    return 128 - index;
}
